import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submit", "token"];

  submit(event) {
    event.preventDefault();
    this.submitTarget.disabled = true;
  }

  process() {
    if (this.isIframe) {
      this.processIframe(this.element);
    } else {
      this.element.submit();
    }
  }

  processIframe(form) {
    const data = new FormData(form);
    const req = new XMLHttpRequest();
    const url = this.element.getAttribute("action");
    const method = this.element.getAttribute("method");
    req.open(method, `${url}.js`, true);
    req.setRequestHeader("X-CSRF-Token", this.csrfToken);
    req.send(data);
    req.onreadystatechange = () => {
      if (req.readyState == 4) {
        if (req.status == 200) {
          window.location = JSON.parse(req.responseText).url;
          this.element.reset();
        } else {
          this.element.submit();
        }
      }
    };
  }

  get csrfToken() {
    const element = document.querySelector('meta[name="csrf-token"]');

    if (element) {
      return element.content;
    } else {
      return null;
    }
  }

  get isIframe() {
    return this.data.get("iframe") === "true";
  }

  get donor() {
    return this.application.controllers.filter((controller) => {
      return controller.identifier.startsWith("donation--donor");
    })[0];
  }
}
